import GenericBody from "../Componentes/GenericBody"
import NavBar from "../Componentes/NavBar"
import { useCallback, useEffect, useState } from "react"
import GenericHeader from "../Componentes/GenericHeader"
import Filters from "../Componentes/Utils/Filters"
import Stats from "../Componentes/Utils/Stats"
import Tabela from "../Componentes/Tabela"
import { formatarData } from "../Funcoes/FormatarData"
import FilterContainer from "../Componentes/Utils/FilterContainer"
import styled from "styled-components"
import useApi from "../hooks/useApi";


const EPIsInfo = () => {
    const api = useApi();


    const [epis, setEpis] = useState([])
    const [episFilter, setEpisFilter] = useState([])

    const fetchData = async () => {

        try {

            const { data } = await api.get('/Painel/API/EPI/GetEPIInfo/')

            console.log(data)

            setEpis(data)
            setEpisFilter(data)

        } catch (e) {

            console.log(e)

        }

    }

    useEffect(() => {

        fetchData();

    }, [])

    const [codEpi, setCodEpi] = useState('')
    const [descEpi, setDescEpi] = useState('')
    const [codForn, setCodForn] = useState('')
    const [nomeForn, setNomeForn] = useState('')
    const [numCA, setNumCA] = useState('')

    const [statusEpi, setStatusEpi] = useState([])

    const [dataInicio, setDataInicio] = useState('')
    const [dataFinal, setDataFinal] = useState('')

    const handleFilter = useCallback(() => {

        setEpisFilter(

            epis.filter((item) => {

                const codEpiFilter = !codEpi || item.CODEPI.includes(codEpi.toUpperCase())
                const descEpiFilter = !descEpi || item.DESCRICAO.includes(descEpi.toUpperCase())
                const codFornFilter = !codForn || item.TN3_FORNEC.includes(codForn)
                const descFornFilter = !nomeForn || item.FORNEC_NOME.includes(nomeForn)
                const numCAPFilter = !numCA || item.NUMCAP.includes(numCA)

                const statusFilter = !statusEpi.length || statusEpi.some(obj => (item.STATUS || '').includes(obj.value))

                const itemDate = new Date(item?.VENCAP);

                const dataInicioFilter = !dataInicio || itemDate >= new Date(dataInicio)
                const dataFinalFilter = !dataFinal || itemDate <= new Date(dataFinal)

                return codEpiFilter && descEpiFilter && codFornFilter && descFornFilter && numCAPFilter && statusFilter && dataInicioFilter && dataFinalFilter;

            })

        )

    }, [epis, codEpi, descEpi, codForn, nomeForn, numCA, statusEpi, dataInicio, dataFinal])

    useEffect(() => {

        handleFilter();

    }, [handleFilter])

    const StatsContainer = styled.div`
            margin: auto;
            display: flex;
            flex-direction: column;
            gap: 5px;
            text-align: center;
            font-weight: bold;
            font-size: 13px;
    `

    const TextoStatTotal = styled.p`
        margin: 0 0 10px 0;
    `

    const TextoStat = styled.p`
        margin: 0;
    `

    return (
        <>
            <NavBar title="LISTA EPI'S" prevDest="modulo/ssma/epi" />
            <GenericBody>
                <GenericHeader>
                    <Filters columns="4" >
                        <FilterContainer
                            type="text"
                            placeholder="CÓDIGO EPI..."
                            valor={codEpi}
                            changeFunc={(valor) => setCodEpi(valor)}
                        />
                        <FilterContainer
                            type="text"
                            placeholder="DESCRIÇÃO EPI..."
                            valor={descEpi}
                            changeFunc={(valor) => setDescEpi(valor)}
                        />
                        <FilterContainer
                            type="text"
                            placeholder="CÓDIGO FORNECEDOR..."
                            valor={codForn}
                            changeFunc={(valor) => setCodForn(valor)}
                        />
                        <FilterContainer
                            type="text"
                            placeholder="NOME FORNECEDOR..."
                            valor={nomeForn}
                            changeFunc={(valor) => setNomeForn(valor)}
                        />
                        <FilterContainer
                            type="text"
                            placeholder="NÚMERO C.A..."
                            valor={numCA}
                            changeFunc={(valor) => setNumCA(valor)}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="STATUS EPI..."
                            options={[
                                { label: 'OK', value: 'OK' },
                                { label: 'A VENCER', value: 'A VENCER' },
                                { label: 'VENCIDO', value: 'VENCIDO' }
                            ]}
                            valor={statusEpi}
                            changeFunc={(valor) => setStatusEpi(valor)}
                        />
                        <FilterContainer
                            type="date"
                            valor={dataInicio}
                            changeFunc={(valor) => setDataInicio(valor)}
                        />
                        <FilterContainer
                            type="date"
                            valor={dataFinal}
                            changeFunc={(valor) => setDataFinal(valor)}
                        />
                    </Filters>
                    <Stats>
                        <StatsContainer>
                            <TextoStatTotal>TOTAL: { episFilter.length }</TextoStatTotal>
                            <TextoStat>VÁLIDOS: { episFilter.filter( obj => obj.STATUS === 'OK' ).length }</TextoStat>
                            <TextoStat>A VENCER: { episFilter.filter( obj => obj.STATUS === 'A VENCER' ).length }</TextoStat>
                            <TextoStat>VENCIDOS: { episFilter.filter( obj => obj.STATUS === 'VENCIDO' ).length }</TextoStat>
                        </StatsContainer>
                        
                    </Stats>
                </GenericHeader>
                <Tabela>
                    <thead>
                        <tr>
                            <th>COD. EPI</th>
                            <th>DESC. EPI</th>
                            <th>FILIAL</th>
                            <th>LOJA</th>
                            <th>NUM. FORNEC</th>
                            <th>FORNECEDOR</th>
                            <th>NUM. C.A.</th>
                            <th>VENC. C.A.</th>
                            <th>DURABILIDADE</th>
                            <th>STATUS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            episFilter.slice(0, 1000).map((obj, index) => (
                                <tr key={index} >
                                    <td>{obj.CODEPI}</td>
                                    <td>{obj.DESCRICAO}</td>
                                    <td>{obj.TN3_FILIAL}</td>
                                    <td>{obj.TN3_LOJA}</td>
                                    <td>{obj.TN3_FORNEC}</td>
                                    <td>{obj.FORNEC_NOME}</td>
                                    <td>{obj.NUMCAP ? obj.NUMCAP : '-'}</td>
                                    <td>{obj.VENCAP ? formatarData(obj.VENCAP) : '-'}</td>
                                    <td>{obj.TN3_DURABI}</td>
                                    <td>{obj.STATUS}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Tabela>
            </GenericBody>
        </>
    )

}

export default EPIsInfo;